// extracted by mini-css-extract-plugin
module.exports = {"closing":"Countdown_closing__WVrEl","blinker":"Countdown_blinker__2LMlU","closingText":"Countdown_closingText__3T7R_"};